(function () {
  'use strict';

  // -----------------------------------------------------------------------
  // CONFIG - replace with the Moana Road Klaviyo public API key
  // Found in Klaviyo > Settings > API Keys > Public API Key
  // -----------------------------------------------------------------------
  var KLAVIYO_PUBLIC_KEY = 'X7Z3Kh';

  // Countries to exclude from seeing the withdrawal link (main domestic markets)
  var EXCLUDED_COUNTRIES = ['NZ', 'AU', 'GB'];

  // -----------------------------------------------------------------------
  // International visitor detection - show link to everyone except NZ, AU, GB
  // Reads country from Liquid-rendered meta tag (set in theme.liquid head)
  // -----------------------------------------------------------------------
  function detectAndShowLink() {
    var meta = document.querySelector('meta[name="visitor-country"]');
    var isoCode = meta ? (meta.getAttribute('content') || '') : '';
    if (EXCLUDED_COUNTRIES.indexOf(isoCode.toUpperCase()) === -1) {
      var link = document.getElementById('eu-withdrawal-link');
      if (link) link.style.display = '';
    }
  }

  // -----------------------------------------------------------------------
  // Modal helpers
  // -----------------------------------------------------------------------
  function openModal() {
    var modal = document.getElementById('eu-withdrawal-modal');
    if (!modal) return;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    var firstInput = modal.querySelector('input');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
  }

  function closeModal() {
    var modal = document.getElementById('eu-withdrawal-modal');
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
    resetForm();
  }

  function resetForm() {
    var form = document.getElementById('eu-withdrawal-form');
    var success = document.getElementById('eu-withdrawal-success');
    var errorMsg = document.getElementById('eu-withdrawal-error-msg');
    var btn = document.getElementById('eu-wd-submit');

    if (form) {
      form.reset();
      form.style.display = '';
      clearFieldErrors();
    }
    if (success) success.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Confirm withdrawal';
    }
  }

  // -----------------------------------------------------------------------
  // Validation
  // -----------------------------------------------------------------------
  function clearFieldErrors() {
    ['eu-wd-name', 'eu-wd-order', 'eu-wd-email'].forEach(function (id) {
      var input = document.getElementById(id);
      var errorEl = document.getElementById(id + '-error');
      if (input) input.removeAttribute('aria-invalid');
      if (errorEl) errorEl.textContent = '';
    });
  }

  function validateForm(name, order, email) {
    var valid = true;

    function setError(inputId, message) {
      var input = document.getElementById(inputId);
      var errorEl = document.getElementById(inputId + '-error');
      if (input) input.setAttribute('aria-invalid', 'true');
      if (errorEl) errorEl.textContent = message;
      valid = false;
    }

    clearFieldErrors();
    if (!name) setError('eu-wd-name', 'Please enter your full name.');
    if (!order) setError('eu-wd-order', 'Please enter your order number.');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('eu-wd-email', 'Please enter a valid email address.');
    }
    return valid;
  }

  // -----------------------------------------------------------------------
  // Klaviyo submission
  // -----------------------------------------------------------------------
  function submitToKlaviyo(name, order, email) {
    var submittedAt = new Date().toISOString();

    return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'EU Withdrawal Submitted' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            properties: {
              name: name,
              order_number: order,
              email: email,
              submitted_at: submittedAt
            }
          }
        }
      })
    });
  }

  // -----------------------------------------------------------------------
  // Event bindings
  // -----------------------------------------------------------------------
  function bindEvents() {
    // Footer link opens modal
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'eu-withdrawal-link') {
        e.preventDefault();
        openModal();
      }
    });

    // Close button (X)
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'eu-withdrawal-close') closeModal();
    });

    // Close button on success screen
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'eu-wd-close-success') closeModal();
    });

    // Overlay click closes modal
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'eu-withdrawal-overlay') closeModal();
    });

    // Esc key closes modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Form submission
    var form = document.getElementById('eu-withdrawal-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var name  = document.getElementById('eu-wd-name').value.trim();
        var order = document.getElementById('eu-wd-order').value.trim();
        var email = document.getElementById('eu-wd-email').value.trim();

        if (!validateForm(name, order, email)) return;

        var btn = document.getElementById('eu-wd-submit');
        var errorMsg = document.getElementById('eu-withdrawal-error-msg');
        btn.disabled = true;
        btn.textContent = 'Submitting\u2026';
        if (errorMsg) errorMsg.style.display = 'none';

        submitToKlaviyo(name, order, email)
          .then(function (res) {
            // Klaviyo returns 202 Accepted on success
            if (res.status === 202 || res.ok) {
              form.style.display = 'none';
              var success = document.getElementById('eu-withdrawal-success');
              if (success) success.style.display = 'block';
            } else {
              throw new Error('Status ' + res.status);
            }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Confirm withdrawal';
            if (errorMsg) errorMsg.style.display = 'block';
          });
      });
    }
  }

  // -----------------------------------------------------------------------
  // Init
  // -----------------------------------------------------------------------
  function init() {
    // Small delay to ensure theme scripts have finished their own DOM manipulation
    setTimeout(detectAndShowLink, 300);
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
